import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import * as icons from '@boxine/tonies-ui/icons';
import styled, { ThemeContext } from 'styled-components';
import { media, variables } from '../themes/theme';
import { AssistiveTechnologyOnly } from '../../styles/AssistiveTechnologyOnly';
import Icon from '../Icon';
const StyledIcon = styled(Icon) `
  min-width: 2rem;
  /* Hide icon visually on small devices */
  @media (max-width: ${variables.screenTablet}px) {
    ${AssistiveTechnologyOnly};
  }

  ${media.tablet `
    margin-right: 2rem;
  `};
`;
export const StatusIcon = ({ type }) => {
    const theme = useContext(ThemeContext);
    const { t } = useTranslation('FlashMessage');
    let color;
    let iconType;
    let iconTitle;
    switch (type) {
        case 'error':
            color = theme.colors.primary;
            iconTitle = t('Error');
            iconType = icons.exclamationMarkFill;
            break;
        case 'info':
            color = theme.colors['lightblue-100'];
            iconTitle = t('Info');
            iconType = icons.infoFill;
            break;
        case 'warning':
            color = theme.colors['yellow-100'];
            iconTitle = t('Warning');
            iconType = icons.exclamationMarkFill;
            break;
        case 'success':
            color = theme.colors['green-100'];
            iconTitle = t('Success');
            iconType = icons.checkmarkFill;
            break;
    }
    return (React.createElement(StyledIcon, { fill: color, height: 32, width: 32, title: iconTitle, type: iconType }));
};
